<form [formGroup]="transportForm">

    <div class="form-group row">
        <div class="col s6">
            <app-input
                type="number"
                [formControl]="transportForm.controls.maxTransportTime"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.transport.max-transport-time.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.transport.max-transport-time.label'
                        | translate
                }}"
            >
            </app-input>
        </div>
    </div>
    <div class="form-group row">
        <div class="col s12">
            <app-multiple-input
                [formControl]="transportForm.controls.lineLocations"
                [inputs]="lineLocations"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.details.location-input.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.locations-input.label'
                        | translate
                }}"
            >
            </app-multiple-input>
        </div>
    </div>

</form>
